<template>
<div class="chapter">
<div class="inner_page">
<div>
<a href="https://theportalist.com/subscribe/?utm_source=In%20Book%20Ad&amp;utm_medium=referral" target="_blank">
<img alt="image" src="port-backad.jpg" style="height:100%; text-align:center;"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// portalistad_1.vue?7f733428